/*
 * Copyright (C) 2026 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useHasModelFeature } from "@simplicitycms/simplicity-common";

/**
 * Shows the children based on model feature settings.
 * - if enabled is passed explicitly it will use this first
 * - uses the `modelFeature` name to lookup if this model feature
 *   is enabled for this model instance.
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */
const ModelFeatureGuard = (props) => {
    const children = props.children;
    const invert = props.invert;
    const modelFeature = props?.modelFeature;
    let featureEnabled = useHasModelFeature(modelFeature);
    let enabled = props.enabled || featureEnabled;
    if (invert) {
        enabled = !enabled;
    }

    if (!enabled) {
        return null;
    }

    return (
        <>
            {children}
        </>
    );
};
ModelFeatureGuard.displayName = "ModelFeatureGuard";
export { ModelFeatureGuard };
